import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: { translations: require('./assets/locales/translate-en.json') },
    id: { translations: require('./assets/locales/translate-id.json') }
}

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        resources,
        ns: ['translations'],
        defaultNS: 'translations',
    });

i18n.languages = ['en', 'id'];
export default i18n;